import { DirectionDocTranslated } from '../../../types/Invoice';
import { PaymentMethod, PaymentMethodTranslated } from '../../../types/Payment';
import { formatPrice } from '../../../utils/functions/data.functions';
import { ColDataType, TableColumn } from '../../table/DataTable.types';

export const columns = (t: (s: string) => string) =>
  [
    {
      accessor: 'source',
      name: 'page.payment.col-source',
    },
    {
      accessor: 'destination',
      name: 'page.payment.col-destination',
    },
    {
      accessor: 'direction',
      name: 'page.payment.col-direction',
      translateEnum: DirectionDocTranslated,
    },
    {
      accessor: 'paymentDate',
      name: 'page.payment.col-date',
      dataType: ColDataType.DATE,
    },
    {
      accessor: 'paymentMethod',
      name: 'page.payment.col-payment-method',
      translateEnum: PaymentMethodTranslated,
      cellRenderer: (e) => (
        <span
          title={e?.paymentMethod === PaymentMethod.OTHER ? e?.paymentSpecifications : undefined}
        >
          {t(PaymentMethodTranslated[e.paymentMethod as PaymentMethod])}
        </span>
      ),
    },
    {
      accessor: 'price',
      name: 'page.payment.col-price',
      className: `text-right ml-auto`,
      cellRenderer: (e) => (
        <span className="ml-auto bold font-bold">
          {formatPrice(e.price)} {e.currency}
        </span>
      ),
    },
  ] as TableColumn[];
